import React from 'react';
import { FormattedMessage } from 'react-intl';

// Backend locale data doesn't currently ship the `validation.*` translation IDs
// that `@htmniseko/htm-validators` emits, so without a defaultMessage react-intl
// falls back to printing the raw ID (e.g. "validation.required") to the user.
// Provide sensible English defaults until backend locales catch up.
const VALIDATION_DEFAULTS = {
  'validation.required': 'This field is required',
  'validation.minLength': 'Must be at least {value} characters',
  'validation.maxLength': 'Must be at most {value} characters',
  'validation.length': 'Must be exactly {value} characters',
  'validation.integer': 'Must be a whole number',
  'validation.noPOBox': 'PO Box addresses are not accepted',
};

// Validators in `@htmniseko/htm-validators` may return either a string or a
// `{ message: <translationId>, value: <interpolation> }` object — the latter is needed
// when a validator's message has a placeholder (e.g. "at least {value} characters").
export default function renderValidationError(error) {
  if (!error) {return null;}
  if (typeof error === 'string') {return error;}
  if (typeof error === 'object' && error.message) {
    return (
      <FormattedMessage
        id={error.message}
        defaultMessage={VALIDATION_DEFAULTS[error.message]}
        values={{ value: error.value }}
      />
    );
  }
  return null;
}
